import { compose, withProps, withHandlers } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { remove } from 'lodash'

import Grid from '../../components/GridView'
import RowDetail from './RowDetail'

const query = gql`
  query {
    customers {
      id
      cod
      name
      email
      phone
    }
  }
`
const withQuery = graphql(query)

const withSave = graphql(
  gql`
    mutation createCustomer($data: CustomerInput!) {
      createCustomer(data: $data) {
        id
        name
        phone
      }
    }
  `,
  {
    name: 'onSave',
    options: {
      update: (proxy, { data: { createCustomer } }) => {
        const data = proxy.readQuery({ query })
        data.customers.push(createCustomer)
        proxy.writeQuery({ query, data })
      }
    }
  }
)

const withUpade = graphql(
  gql`
    mutation updateCustomer($id: ID!, $data: CustomerInput!) {
      updateCustomer(id: $id, data: $data) {
        id
        cod
        name
        phone
      }
    }
  `,
  {
    name: 'onUpdate'
  }
)

const withDelete = graphql(
  gql`
    mutation deleteCustomer($id: ID!) {
      deleteCustomer(id: $id) {
        id
      }
    }
  `,
  {
    name: 'onDelete',
    options: {
      update: (proxy, { data: { deleteCustomer } }) => {
        const data = proxy.readQuery({ query })
        remove(data.customers, deleteCustomer)
        proxy.writeQuery({ query, data })
      }
    }
  }
)

export default compose(
  withQuery,
  withSave,
  withUpade,
  withDelete,
  withProps(({ data }) => ({
    columns: [
      { name: 'cod', title: 'CPF/CNPJ', type: 'code' },
      { name: 'name', title: 'CLIENTE', sort: 'asc' },
      { name: 'email', title: 'EMAIL' },
      { name: 'phone', title: 'SMS', type: 'phone' }
    ],
    extensions: [
      { columnName: 'cod', width: 150 },
      { columnName: 'phone', width: 150, align: 'center' }
    ],

    // detailComponent: RowDetail,
    loading: data.loading,
    detailComponent: RowDetail,
    rows: data.customers || []
  })),
  withHandlers({
    handleSave: ({ onSave }) => data => {
      console.log(data)
      onSave({ variables: { data } })
    },
    handleUpdate: ({ onUpdate }) => ({ id, data }) => {
      onUpdate({ variables: { id, data } })
    },
    handleDelete: ({ onDelete }) => id => {
      onDelete({ variables: { id } })
    }
  })
)(Grid)
